import { type CSSProperties } from 'react';
import { IListItem } from '../../interfaces'
import '../styles/ListItem.css';
import '../../utils/GlobalStyles.css';
import Text from '../main/Text';
import Icon from '../main/Icon';
import { getTranslatedLabel, getProtocolUrl } from '../../utils/translations';
import type { TemplateStatEvent } from '../../template/contract';

// Abschliessende Zuordnung Titel → Ereignisart (Kontrakt v3, T-31). Muss Wort
// fuer Wort mit den `click:*`-Eintraegen aus STAT_EVENTS uebereinstimmen
// (Backend: src/vcard/lifecycle.config.ts) — nur diese acht Titel kommen aus
// ContactsList vor, `click:save-contact`/`click:navigation` gehoeren nicht
// zu ListItem.
const STAT_EVENT_FOR_TITLE: Record<string, TemplateStatEvent> = {
    'Cell telephone number': 'click:mobile',
    'Work telephone number': 'click:phone',
    'Email': 'click:email',
    'WhatsApp': 'click:whatsapp',
    'Facebook Messenger': 'click:facebook',
    'LinkedIn': 'click:linkedin',
    'Google Business Message': 'click:google-business',
    'Website': 'click:website',
};

const icons =
{
    'Cell telephone number': <Icon icon = 'phone'/>,
    'Work telephone number': <Icon icon = 'phone' />,
    'Email': <Icon icon = 'envelope' />,
    'WhatsApp': <Icon icon = 'whatsapp' size = '28px'/>,
    'Facebook Messenger': <Icon icon = 'facebook' size = '25px' />,
    'LinkedIn': <Icon icon = 'linkedin' size = '25px' />,
    'Google Business Message': <Icon icon = 'google' size = '23px'/>,
    'Website': <Icon icon = 'desktop'/>
}

function ListItem({ title, value, displayValue, onEvent }: IListItem)
{
    const translatedTitle = getTranslatedLabel(title);
    // Der Link bleibt IMMER am Rohwert (value, z. B. E.164 bei Telefonnummern) —
    // nur der sichtbare Text darf abweichen (displayValue).
    const protocolUrl = getProtocolUrl(title, value);

    // Hide value text for WhatsApp, Facebook and LinkedIn completely
    const visibleText = (title === 'WhatsApp' || title === 'Facebook Messenger' || title === 'LinkedIn')
        ? ''
        : (displayValue ?? value);

    const handleClick = () => {
        // Zaehlung zuerst (fire-and-forget, siehe reportStatEvent) — darf das
        // Oeffnen nie verzoegern oder verhindern, deshalb synchron und ohne
        // await, bevor window.open laeuft.
        const event = STAT_EVENT_FOR_TITLE[title];
        if (event) onEvent?.(event);

        // Open WhatsApp, Facebook, LinkedIn, and Website links in new window/tab
        if (title === 'WhatsApp' || title === 'Facebook Messenger' || title === 'LinkedIn' || title === 'Website') {
            window.open(protocolUrl, '_blank');
        } else {
            window.open(protocolUrl, '_self');
        }
    };

    return (
        <div
            className = 'data-container shadow list-item-clickable'
            style = {{ '--item-hover': sessionStorage.getItem('primaryColor') as string } as CSSProperties}
            onClick={handleClick}
        >
            <div style = {{ paddingRight: '15px'}}>
                <Text text = {translatedTitle} fontSize = {16} fontWeight = {700}/>
                <Text text = {visibleText} fontSize={16} fontWeight={300} />
            </div>

            {Object(icons)[title]}
        </div>
    )
}

export default ListItem